import firebase from 'firebase/app';
import { CollectionName } from '@tomis-tech/types';

import { FIREBASE } from '../../firebase';
import { logError } from '.././sentry-iframe';
import { SITE_SLUG } from '../consts';

/** Mark ChatBot Message as `seenBy` user.
 *
 * Errors will be logged to Sentry, but they are not shown to user...*/
export async function markMessageAsRead({
  conversationId,
  messageId,
  userId,
}: {
  /** InboxConversation ID to mark as seen by User */
  conversationId: string;
  /** Message to mark as seen by User */
  messageId: string;
  /** TOMIS User or Firebase User that saw the message */
  userId: string;
}) {
  // need all data, else firebase error will occur
  if (SITE_SLUG && conversationId && messageId && userId) {
    return FIREBASE.db
      .collection(CollectionName.Sites)
      .doc(SITE_SLUG)
      .collection(CollectionName.Conversations)
      .doc(conversationId)
      .collection(CollectionName.Messages)
      .doc(messageId)
      .update({
        seenBy: firebase.firestore.FieldValue.arrayUnion(userId),
      })
      .catch(logError);
  }
}
